import * as React from 'react';
import Select from '@material-ui/core/Select';

const CustomSelect = (props) => {
    return <Select {...props} />;
};

export { CustomSelect as Select };
